import { createSlice } from "@reduxjs/toolkit";
import { getPaycheckIllustrationAPI } from "../../../services/guestUsers/guestUserAllAPIService";

const initialState = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
};

const getPaycheckIllustrationSlice = createSlice({
  name: "getPaycheckIllustrationSlice",
  initialState,
  reducers: {
    getPaycheckIllustrationSliceInfo(state) {
      state.isLoading = true;
      state.message = "";
    },
    getPaycheckIllustrationSliceSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    getPaycheckIllustrationSliceFailure(state, action) {
      state.isLoading = false;
      state.message = action.payload;
      state.data = null;
    },
    getPaycheckIllustrationSliceReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
    },
  },
});

export const getPaycheckIllustrationHandler =
  (payload = {}) => async (dispatch) => {
    try {
      dispatch(
        getPaycheckIllustrationSliceAction.getPaycheckIllustrationSliceInfo(),
      );
      const response = await getPaycheckIllustrationAPI(payload);
      dispatch(
        getPaycheckIllustrationSliceAction.getPaycheckIllustrationSliceSuccess(
          response,
        ),
      );
    } catch (e) {
      const msg =
        typeof e === "string"
          ? e
          : e?.message || "Unable to load paycheck illustration";
      dispatch(
        getPaycheckIllustrationSliceAction.getPaycheckIllustrationSliceFailure(
          msg,
        ),
      );
    }
  };

export default getPaycheckIllustrationSlice.reducer;
export const getPaycheckIllustrationSliceAction =
  getPaycheckIllustrationSlice.actions;
